import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueSchemeDetailTopologyPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        schemeDetail: {
          topologyPicker: {
            title: "查找拓扑版本",
            confirm: "带回拓扑版本",
            pick: "查找带回",
            clear: "清空",
            placeholder: "搜索拓扑版本名称或编码",
            displayPlaceholder: "请选择已发布的拓扑版本",
            loadFailed: "加载拓扑版本失败",
            selectFirst: "请先选择一个拓扑版本。",
            scopes: {
              mine: "我的",
              sharedWithMe: "共享给我",
              public: "公共",
            },
          },
          topologyPreview: {
            title: "拓扑图预览",
            ariaLabel: "已绑定拓扑版本的只读拓扑图预览",
            empty: "当前拓扑版本没有可预览的拓扑图快照。",
          },
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        schemeDetail: {
          topologyPicker: {
            title: "Find Topology Version",
            confirm: "Return Topology Version",
            pick: "Find and Return",
            clear: "Clear",
            placeholder: "Search topology version name or code",
            displayPlaceholder: "Select a published topology version",
            loadFailed: "Failed to load topology versions",
            selectFirst: "Select a topology version first.",
            scopes: {
              mine: "Mine",
              sharedWithMe: "Shared with Me",
              public: "Public",
            },
          },
          topologyPreview: {
            title: "Topology Preview",
            ariaLabel: "Read-only topology preview for the bound topology version",
            empty: "This topology version does not have a previewable graph snapshot.",
          },
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        schemeDetail: {
          topologyPicker: {
            title: "トポロジー版を検索",
            confirm: "トポロジー版を反映",
            pick: "検索して反映",
            clear: "クリア",
            placeholder: "トポロジー版名またはコードを検索",
            displayPlaceholder: "公開済みトポロジー版を選択",
            loadFailed: "トポロジー版の読み込みに失敗しました",
            selectFirst: "先にトポロジー版を選択してください。",
            scopes: {
              mine: "自分のもの",
              sharedWithMe: "共有されたもの",
              public: "公開",
            },
          },
          topologyPreview: {
            title: "トポロジープレビュー",
            ariaLabel: "紐付け済みトポロジー版の読み取り専用プレビュー",
            empty: "このトポロジー版にはプレビュー可能なグラフスナップショットがありません。",
          },
        },
      },
    },
  },
};
